import React from 'react';
import PropTypes from 'prop-types';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import ButtonCollapse from 'components/Widgets/ButtonCollapse';
import ListItem from './ListItem';

export default function List({ currentChat, setChat, chats }) {
  if (chats === null) {
    return (
      <section>
        <LoadingPlaceholder text="Loading..." />
      </section>
    );
  }

  const activeChats = chats ? chats.filter((item) => item.attributes.student_archived_at === null) : [];
  const archiveChats = chats ? chats.filter((item) => item.attributes.student_archived_at !== null) : [];

  return (
    <>
      <div className="rce-container-clist chat-list">
        <h3 className="ms-2 me-2">Contacts</h3>
        {activeChats.length === 0
          ? <p className="ms-2 me-2">There are no active contacts</p> : activeChats.map((chat) => (
            <ListItem
              key={chat.id}
              chat={chat}
              currentChat={currentChat}
              setChat={setChat}
            />
          ))}

      </div>

      <div className="m-2 d-flex justify-content-between align-items-center">
        <p><b>Archive</b></p>
        <ButtonCollapse target=".archive" controls="archive" expanded />
      </div>

      <div className="rce-container-clist chat-list archive collapse show">
        {archiveChats.length === 0
          ? <p className="ms-2 me-2">There are no archived contacts</p> : archiveChats.map((chat) => (
            <ListItem
              key={chat.id}
              chat={chat}
              currentChat={currentChat}
              setChat={setChat}
            />
          ))}
      </div>

    </>

  );
}

List.propTypes = {
  currentChat: PropTypes.object,
  setChat: PropTypes.func.isRequired,
  chats: PropTypes.arrayOf(PropTypes.object),
};

List.defaultProps = {
  currentChat: null,
  chats: null,
};
